export const GRAPHQL_BASE_URL =
  "https://web.np.playstation.com/api/graphql/v1/op";
